import React from "react";
import { useSelector } from "react-redux";
import Employment from "../../components/employment/employment";
import DateStarted from "../../components/dateStarted/dateStarted";
import BusinessName from "../../components/businessName/businessName";
import IncomeFrequency from "../../components/income/incomeFrequency";
import IncomeField from "../../components/income/incomeField";
import { useSetOnSubmitDefault } from "../../context/formContext/submitButton";
import SectionHeading from "@components/sectionHeading";
import { MarginLeftRow, PaddingLeftCol } from "@components/leftGrid";
import { useSetDefaultValue } from "@hooks";
import { FIELD_NAMES } from "@src/constants/commonConstants";
import ErrorWell from "@src/components/errorWell";

export const LivelihoodStep = (props) => {
  const {
    errors,
    touched,
  } = props;
  const { queryTheme, queryString: { utm_campaign, utm_source, utm_medium } } = useSelector((state) => state.StartUp);

  useSetOnSubmitDefault();
  useSetDefaultValue(FIELD_NAMES.UTM_VALUES,  { [FIELD_NAMES.UTM_CAMPAIGN]: utm_campaign, [FIELD_NAMES.UTM_SOURCE]: utm_source, [FIELD_NAMES.UTM_MEDIUM]: utm_medium, [FIELD_NAMES.THEME]: queryTheme });

  return (
    <MarginLeftRow>
      <PaddingLeftCol sm={12}>
        <SectionHeading heading="Your Livelihood & Income" asMobileHeader soft/>
        <ErrorWell errors={errors} touched={touched}/>
      </PaddingLeftCol>
      <PaddingLeftCol sm={12} md={6}>
        <Employment />
      </PaddingLeftCol>
      <PaddingLeftCol sm={12} md={6}>
        <DateStarted />
      </PaddingLeftCol>
      <PaddingLeftCol sm={12} md={6} style={{ marginTop: 14 }}>
        <BusinessName />
      </PaddingLeftCol>
      <PaddingLeftCol sm={12} md={6}>
        <IncomeFrequency />
      </PaddingLeftCol>
      <PaddingLeftCol sm={12} md={6}>
        <IncomeField />
      </PaddingLeftCol>
    </MarginLeftRow>
  )
};